"use client";

import { usePathname } from "next/navigation";
import { MusicPlayerFloatingPopup } from "@/components/MusicPlayerFloatingPopup";

/**
 * Popup tròn kéo thả — hiển thị khi ở các trang khác home.
 * Trên home dùng turntable trong hero. State nhạc đồng bộ toàn website nhờ MusicPlayerContext.
 */
export function GlobalMusicPlayer() {
  const pathname = usePathname();
  const isHome = pathname === "/" || pathname === "";
  if (isHome) return null;

  return (
    <div className="print:hidden">
      <MusicPlayerFloatingPopup />
    </div>
  );
}
